type SmileSimulationEmptyStateProps = {
  actionLabel?: string;
  description: string;
  onAction?: () => void;
  title: string;
};

export function SmileSimulationEmptyState({
  actionLabel,
  description,
  onAction,
  title,
}: SmileSimulationEmptyStateProps) {
  return (
    <div className="bg-white/88 w-full rounded-[1.75rem] border border-white/70 p-6 text-center shadow-[0_18px_45px_rgba(17,17,17,0.06)] backdrop-blur-sm">
      <h3 className="text-lg font-semibold text-[#1f1230]">{title}</h3>
      <p className="mt-2 text-sm leading-6 text-[#6b577d]">{description}</p>
      {actionLabel && onAction ? (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 rounded-full bg-[#8F14E5] px-5 py-3 text-sm font-semibold text-white shadow-[0_12px_30px_rgba(143,20,229,0.22)] transition hover:bg-[#7d10ca]"
        >
          {actionLabel}
        </button>
      ) : null}
    </div>
  );
}
